import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://localhost:7000/api'
const API_ORIGIN = new URL(API_BASE_URL).origin

const api = axios.create({
  baseURL: API_BASE_URL,
})

export const resolveMediaUrl = (url) => {
  if (!url) return ''
  if (url.startsWith('http://') || url.startsWith('https://')) return url
  return `${API_ORIGIN}${url}`
}

export const salonAPI = {
  // Studio
  getStudio: () => api.get('/studio'),

  // Services
  getServices: () => api.get('/services'),
  getServicesByCategory: (category) => api.get(`/services/category/${category}`),
  getService: (id) => api.get(`/services/${id}`),
  createService: (data) => api.post('/services', data),
  updateService: (id, data) => api.put(`/services/${id}`, data),
  deleteService: (id) => api.delete(`/services/${id}`),

  // Bookings
  getBookings: () => api.get('/bookings'),
  getBooking: (id) => api.get(`/bookings/${id}`),
  getBookingsByDate: (date) => api.get(`/bookings/date/${date}`),
  getAvailableTimes: (serviceId, date) => api.get(`/bookings/available-times/${serviceId}/${date}`),
  createBooking: (data) => api.post('/bookings', data),
  updateBooking: (id, data) => api.put(`/bookings/${id}`, data),
  cancelBooking: (id) => api.delete(`/bookings/${id}`),

  // Staff
  getStaff: () => api.get('/staff'),
  getStaffMember: (id) => api.get(`/staff/${id}`),
  getStaffBySpecialty: (specialty) => api.get(`/staff/specialty/${specialty}`),

  // Gallery
  getGallery: () => api.get('/gallery'),
  getGalleryByCategory: (category) => api.get(`/gallery/category/${category}`),
  getGalleryImage: (id) => api.get(`/gallery/${id}`),

  // Reviews
  getReviews: () => api.get('/reviews'),
  getReview: (id) => api.get(`/reviews/${id}`),
  getAverageRating: () => api.get('/reviews/average-rating'),
  createReview: (data) => api.post('/reviews', data),
  approveReview: (id) => api.put(`/reviews/${id}/approve`),
  deleteReview: (id) => api.delete(`/reviews/${id}`),
}

export default api
